import styled from 'styled-components'
import { ASSETS } from '../../../../../constants/assets'

export const LeadershipModalHolder = styled.div<{
  $contentType: string
}>`
  display: flex;
  flex-direction: row;
  align-items: ${({ $contentType }) => ($contentType === 'speakerText' ? 'start' : 'center')};

  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &.PageEventSpeaker {
    .PageEventSpeaker__Image {
      border-radius: 50%;
      object-fit: cover;
      width: 250px;
      height: 250px;
    }
  }
`

export const LeadershipModalImage = styled.div`
  width: 250px;
  height: 288px;

  img {
    width: 250px;
    height: 288px;
    object-fit: contain;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: auto;
    height: auto;
    aspect-ratio: 278 / 320;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

export const LeadershipModalContent = styled.div`
  display: flex;
  width: 414px;
  flex-direction: column;
  margin-left: 32px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
    margin: auto;
  }
`

export const RowContent = styled.div`
  &.Content-FullName {
    margin-top: 16px;
  }

  &.Content-Role {
    margin-top: 2px;
  }

  &.Content-MiniBio {
    margin-top: 16px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    &.Content-FullName {
      margin-top: 32px;
    }

    &.Content-MiniBio {
      min-height: unset;
    }
  }
`

export const LeadershipModalFooter = styled.div`
  display: flex;
  margin-top: 24px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-top: 16px;
  }

  .Content-LinkProfile {
    display: flex;
    margin-right: 18px;

    .BioCardFooter-LinkedInProfile,
    .BioCardFooter-TwitterProfile {
      margin-right: 10px;
    }

    &:hover {
      .BioCardFooter-ProfileType {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }

      .BioCardFooter-TwitterProfile {
        background-image: url(${ASSETS.TWITTER_HOVER});
      }

      .BioCardFooter-LinkedInProfile {
        background-image: url(${ASSETS.LINKEDIN_HOVER});
      }
    }
  }
`

export const LinkItem = styled.div`
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  &.BioPost__SocialMedia-Item svg {
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }
  &.BioPost__SocialMedia-Item svg:hover path {
    fill: ${({ theme }) => theme.webMktPalette.icon.blueLight};
  }

  &.BioCardFooter-TwitterProfile {
    margin-top: 2px;
    background-image: url(${ASSETS.TWITTER});
  }

  &.BioCardFooter-LinkedInProfile {
    background-image: url(${ASSETS.LINKEDIN});
  }
`
